import { createAppConfig } from '~app/sdk';
import { LocalesEnum } from '~core/modules/l10n/constants/locales.enum';

export const environment = {
  appId: 'app-buyer',
  production: true,
  test: false,
  logLevel: () => createAppConfig().logLevel,
  originalUrl: () => createAppConfig().originalUrl,
  countryDomainCode: () => createAppConfig().countryDomainCode,
  featureConfig: () => createAppConfig().featureConfig,
  metroAppsBaseUrl: () => createAppConfig().metroAppsBaseUrl,
  compaasCDNBaseUrl: () => createAppConfig().compaasCDNBaseUrl,
  myMetroBaseUrl: () => createAppConfig().myMetroBaseUrl,
  myMetroCountryBaseUrl: () => createAppConfig().myMetroCountryBaseUrl,
  metroDocsBaseUrl: () => createAppConfig().metroDocsBaseUrl,
  appBaseUrl: () => createAppConfig().appBaseUrls.buyer,
  appSellerUrl: () => createAppConfig().appBaseUrls.seller,
  cdnBaseUrl: () => createAppConfig().serviceBaseUrls.cdn,
  svcPlatformBaseUrl: () => createAppConfig().serviceBaseUrls.platform,
  svcImsBaseUrl: () => createAppConfig().serviceBaseUrls.ims,
  svcSellerOfficeBaseUrl: () => createAppConfig().serviceBaseUrls.sellerOffice,
  svcSellerPimBaseUrl: () => createAppConfig().serviceBaseUrls.sellerPim,
  svcSellerInventoryBaseUrl: () => createAppConfig().serviceBaseUrls.sellerInventory,
  svcUserAccountBaseUrl: () => createAppConfig().serviceBaseUrls.userAccount,
  svcBuyerAccountBaseUrl: () => createAppConfig().serviceBaseUrls.buyerAccount,
  svcCheckoutBaseUrl: () => createAppConfig().serviceBaseUrls.checkout,
  getSvcStorefrontBaseUrl: () => createAppConfig().serviceBaseUrls.storefront,
  svcProductIndex: () => createAppConfig().serviceBaseUrls.productIndex,
  svcProductDetail: () => createAppConfig().serviceBaseUrls.productDetail,
  svcSearchBaseUrl: () => createAppConfig().serviceBaseUrls.search,
  svcSearch2BaseUrl: () => createAppConfig().serviceBaseUrls.search2,
  svcStoryblokBridgeBaseUrl: () => createAppConfig().serviceBaseUrls.storyblokBridge,
  svcGenericBaseUrl: () => createAppConfig().serviceBaseUrls.generic,
  svcOrderManagementBaseUrl: () => createAppConfig().serviceBaseUrls.orderManagement,
  serviceBuyerGatewayBaseUrl: () => createAppConfig().serviceBaseUrls.serviceBuyerGateway,
  svcCartBaseUrl: () => createAppConfig().serviceBaseUrls.cart,
  svcCmsBaseUrl: () => createAppConfig().serviceBaseUrls.cmsBaseUrl,
  svcCrmBaseUrl: () => createAppConfig().serviceBaseUrls.crmBaseUrl,
  svcBuyerCategories: () => createAppConfig().serviceBaseUrls.buyerCategories,
  svcStorageBucketUrl: () => createAppConfig().serviceBaseUrls.storageBucketUrl,
  imgixProductBaseUrl: () => createAppConfig().serviceBaseUrls.imgixProductBaseUrl,
  metronomCSSBaseUrl: () => createAppConfig().serviceBaseUrls.metronomCSSBaseUrl,
  svcAnonymousEmailsBaseUrl: () => createAppConfig().serviceBaseUrls.anonymousEmailsBaseUrl,
  captchaSiteKey: () => createAppConfig().captchaSiteKey,
  locale: () => createAppConfig().locale || LocalesEnum.de,
  appStaticUrl: () => createAppConfig().appStaticUrl,
  adyenEnv: () => createAppConfig().adyenEnv,
  adyenLocalOrigin: () => createAppConfig().adyenLocalOrigin,
  configCatSdkKey: () => createAppConfig().configCatSdkKey,
  gaTrackingId: () => createAppConfig().gaTrackingId,
  ga4TrackingId: () => createAppConfig().ga4TrackingId,
  gaGtmParams: () => createAppConfig().gaGtmParams,
  ga4GtmParams: () => createAppConfig().ga4GtmParams,
  adyenVersion: () => createAppConfig().adyenVersion,
  baseHref: () => createAppConfig().baseHref,
  sentryDsn: () => createAppConfig().sentryDsn,
  metroSellerId: () => createAppConfig().metroSellerId,
  IDAMSSO: () => createAppConfig().IDAMSSO,
  paypalClientId: () => createAppConfig().paypalClientId,
  pipelineId: () => createAppConfig().pipelineId,
  appEnv: () => createAppConfig().appEnv,
  sentryRelease: () => createAppConfig().sentryRelease,
  optimizelySdkKey: () => createAppConfig().optimizelySdkKey,
  storyToken: () => createAppConfig().storyToken,
  freshDeskUrl: () => createAppConfig().freshDeskUrl,
  svcOrderBuyerSearchBaseUrl: () => createAppConfig().serviceBaseUrls.orderBuyerSearchBaseUrl,
  ratepaySnippetId: () => createAppConfig().ratepaySnippetId,
  ravelinPublishableKey: () => createAppConfig().ravelinPublishableKey,
  multiMarketsCentral: () => createAppConfig().multiMarketsCentralAPI,
  criteoBaseUrl: () => createAppConfig().criteoBaseUrl,
};
